import React, {useCallback, useEffect, useState} from 'react';
import TextBox from '../components/textbox'
import ButtonComp from '../components/button'
import Label from '../components/label'
import Button from '@material-ui/core/Button';
import DropDown from '../components/dropDown'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import WarningModal from '../components/modal'
import '../styling/containerStyles.css'

interface DealerDetailsProps{
    handleDealerContractorDetails:Function;
    handleToUpdateVerified:Function;
}

export const DealerDetails: React.FC<DealerDetailsProps> = (props: DealerDetailsProps) =>{

    const{
        handleDealerContractorDetails, handleToUpdateVerified
    } = props;

    const [dealerName, setDealerName] = useState('')
    const [contractorName, setContractorName] = useState('')
    const [dealerMobile, setDealerMobile] = useState('')
    const [contractorMobile, setContractorMobile] = useState('')
    const [profession, setProfession] = useState('Select')
    const [pincode, setPincode] = useState('')
    const [message, setMessage] = useState('')
    const [locationBlocked, setLocationBlocked] = useState(false)
    const [isPinDisabled, setIsPinDisabled] = useState(true);

    const urlParams = new URLSearchParams(window.location.search);
    const dealerPhone = urlParams.get('dealer');

    useEffect(() => {
        dealerPhone && setDealerMobile(dealerPhone);
    }, [dealerPhone]);

    useEffect(() => {  
        if(navigator.permissions) {
            navigator.permissions.query({name: 'geolocation'})
                .then(res => {
                    if(res.state === 'denied') {
                        setIsPinDisabled(false);
                    }
                })
        }        
    }, []);
    
    const handleToUpdateContent = (name:string, arg: string) => {
        if(name === 'dealerName') {
            setDealerName(arg)
        }
        if(name === 'dealerMobile') {
            setDealerMobile(arg)
        }
        if(name === 'contractorName') {
            setContractorName(arg)
        }
        if(name === 'contractorMobile') {
            setContractorMobile(arg)
        }
        if(name === 'pincode') {
            const newValue = arg?.replace(/\D/g, "")?.substring(0, 6);
            setPincode(newValue);
        }
    }

    const handleToUpdateProfession = (arg: string) => {
        setProfession(arg)
    }

    const handleToUpdateAdd = (arg: string) => {
        var re = /^[0-9]{10}$/;
        const data = {
            "dealerName": dealerName,
            "dealerMobile": dealerMobile,
            "contractorName": contractorName,
            "contractorMobile": contractorMobile,
            "profession": profession,
            "pincode": pincode
        }
        
        if(dealerName.length === 0){
            setMessage('Please enter a valid dealer name')
            setDealerName('')
        }
        else if(re.test(dealerMobile) === false){
            setMessage('Please enter a valid dealer contact number')
            setDealerMobile('')
        }
        else if(contractorName.length === 0){
            setMessage('Please enter a valid contractor name')
            setContractorName('')
        }
        else if(re.test(contractorMobile) === false){
            setMessage('Please enter a valid contractor contact number')
            setContractorMobile('')
        }
        else if(dealerMobile === contractorMobile){
            setMessage('Dealer contact number and Contractor contact number can not be same')
        }
        else if(profession === 'Select' || profession === ""){
            setMessage('Please choose a valid profession ')
            setProfession('')
        }
        else if(pincode.length !== 6){
            setMessage('Invalid Pincode')
            setPincode('')
        }
        else {
            setMessage('')
            handleToUpdateVerified(contractorMobile)
            handleDealerContractorDetails(data)
        }
    }
        // localStorage.removeItem("x-refresh-token");
        // localStorage.removeItem("x-access-token");
        // localStorage.removeItem("phone_number");
        // localStorage.removeItem("IS_LOGIN");

    const heading = "Location Disabled !!"
    const content = "Please allow location permissions to continue"
    
    const getLocn = () => {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                var geocoder = new google.maps.Geocoder();
                var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                geocoder.geocode({ 'location': latlng },(results, status) => {
                    if (status === google.maps.GeocoderStatus.OK && results[0]) {
                        for (var j = 0; j < results[0].address_components.length; j++) {
                            if (results[0].address_components[j].types[0] === 'postal_code') {
                                setPincode(results[0].address_components[j].long_name)
                            }
                        }
                            // var address = results[0].formatted_address.split(',')
                            // address = address[address.length-2].split(' ')
                            // setPincode(address[address.length - 1])
                    }
                })
            },
            (err) => {
                setLocationBlocked(true);
                setIsPinDisabled(false);
            }
        );
    }

    const handleClose = useCallback(() => {
        setLocationBlocked(false);
    }, [locationBlocked]);

        let dropDownItems = [];
        dropDownItems = ['Select', 'Waterproofer', 'Kothi contractor', 'Painting Contractor', 'Plumbing Contractor', 'Mason', 'Painter', 'Others'];

        return (
            <div className='custDetails' >
                {
                    locationBlocked && <WarningModal heading={heading} content={content} isOpen={locationBlocked} handleClose={handleClose}/>
                }
                    <div className='buttonAndLabel'>
                        <Button className='goBack' onClick={() => {handleDealerContractorDetails('GoBack')}} ><ArrowBackIosIcon /></Button> 
                        <Label content='Dealer Details' />
                    </div>
                    <br></br>
                    {/* <Label content='Dealer Details' /> */}
                    <TextBox className='textBox custom_input'
                                label={'Dealer Name'} 
                                state={'dealerName'}
                                placeholder={'Input dealer name'} 
                                handleToUpdate={handleToUpdateContent} />

                    <TextBox className='textBox custom_input'
                                label={'Dealer Contact Number'} 
                                state={'dealerMobile'}
                                defaultValue={dealerMobile}
                                placeholder={'Input dealer contact number'} 
                                handleToUpdate={handleToUpdateContent} />
                    
                    <TextBox className='textBox custom_input'
                                label={'Contractor Name'} 
                                state={'contractorName'}
                                placeholder={'Input contractor name'} 
                                handleToUpdate={handleToUpdateContent} />

                    <TextBox className='textBox custom_input'
                                label={'Contractor Contact Number'} 
                                state={'contractorMobile'}
                                placeholder={'Input contractor contact number'} 
                                handleToUpdate={handleToUpdateContent} />

                        <DropDown item={dropDownItems}
                            name='profession'
                            label='Profession of Contractor' 
                            handleToUpdate={handleToUpdateProfession}/>

                    <div className='pincodeBox'>
                        <div className='box1'>
                            <TextBox className='textBox custom_input'
                                label={'Pin Code of Contractor'}
                                state={'pincode'}
                                placeholder={'Eg: 560042'}
                                defaultValue={pincode} 
                                handleToUpdate={handleToUpdateContent}
                                disabled={isPinDisabled} 
                            />    
                        </div>
                        <div className='box2'>
                            <IconButton 
                                disabled={false}
                                onClick={getLocn}
                            >
                                <GpsFixedIcon />
                            </IconButton>
                        </div>
                    </div>

                    <div className='message'>{message}</div>
                    
                    <ButtonComp label= {'Pin Code'} 
                            name={'ADD'} 
                            visible={true}
                            handleToUpdate={handleToUpdateAdd}  />
            </div>             
        )
    }


export default DealerDetails